/**
 * 骨組み（App）から各画面へ渡す操作。prop で何段も渡さないために context にする。
 */
import { createContext, use } from "react";

export interface Shell {
  /** 画面を移る（ハッシュ）。View Transition に乗せる。 */
  go: (hash: string) => void;
  /** 横断検索（⌘K / 上部の検索アイコン）を開く。 */
  openSearch: () => void;
}

export const ShellContext = createContext<Shell>({
  go: (h) => { location.hash = h; },
  openSearch: () => {},
});

export function useShell(): Shell {
  return use(ShellContext);
}

// 画面を移ったら、新しい画面の見出し（h1）へフォーカスを移す（読み上げの位置を新しい画面に合わせる）。
// 初回表示では移さない。PageHeader がマウント時に消費する。
let headingFocusPending = false;
export function requestHeadingFocus(): void { headingFocusPending = true; }
export function consumeHeadingFocus(): boolean {
  const v = headingFocusPending;
  headingFocusPending = false;
  return v;
}
